(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue2-org-tree", [], factory);
	else if(typeof exports === 'object')
		exports["vue2-org-tree"] = factory();
	else
		root["vue2-org-tree"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_org_tree__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_org_tree__["a" /* default */]);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__org_tree_vue__ = __webpack_require__(2);


function install(Vue) {
  if (install.installed) {
    return;
  }

  install.installed = true;

  Vue.component(__WEBPACK_IMPORTED_MODULE_0__org_tree_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__org_tree_vue__["a" /* default */]);
}

__WEBPACK_IMPORTED_MODULE_0__org_tree_vue__["a" /* default */].install = install;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(__WEBPACK_IMPORTED_MODULE_0__org_tree_vue__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__org_tree_vue__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_org_tree_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f24c2d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_org_tree_vue__ = __webpack_require__(7);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_org_tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f24c2d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_org_tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Vue2OrgTree",
  data: function data() {
    return {
      dragState: {
        dragg: null,
        drop: null
      }
    };
  },

  components: {
    OrgTreeNode: {
      render: __WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */],
      functional: true
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          label: "label",
          expand: "expand",
          children: "children"
        };
      }
    },
    horizontal: Boolean,
    selectedKey: String,
    collapsable: Boolean,
    renderContent: Function,
    labelWidth: [String, Number],
    labelClassName: [Function, String],
    selectedClassName: [Function, String]
  },
  methods: {
    onDragStart: function onDragStart(event, data) {
      var dragState = this.dragState;
      try {
        event.dataTransfer.setData("text/plain", "");
      } catch (e) {}
      dragState.drag = data;
    },
    onDragOver: function onDragOver(event, data) {
      event.preventDefault();
    },
    onDrop: function onDrop(event, data) {
      event.preventDefault();
      var dragState = this.dragState;
      var drag = dragState.drag;
      dragState.drop = data;
      this.$emit("on-node-drop", event, drag, data);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export renderNode */
/* unused harmony export renderBtn */
/* unused harmony export renderLabel */
/* unused harmony export renderChildren */
/* unused harmony export render */
var EVENTS = {
  CLICK: 'on-node-click',
  MOUSEOUT: 'on-node-mouseout',
  MOUSEOVER: 'on-node-mouseover',
  DRAGSTART: 'on-node-drag-start',
  DRAGOVER: 'on-node-drag-over',
  DROP: 'on-node-drop'
};

function createListener(handler, data) {
  var execute = function execute(cb, e) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    if (typeof cb === 'function') {
      // fixed bug #48, #73
      var className = e.target && e.target.className;
      if (typeof className === 'string' && className.indexOf('org-tree-node-btn') > -1) return;

      cb.apply(null, [e].concat(args));
    }
  };

  return function (e) {
    if (Array.isArray(handler)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = handler[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cb = _step.value;

          execute(cb, e, data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      execute(handler, e, data);
    }
  };
}

// 判断是否叶子节点
var isLeaf = function isLeaf(data, prop) {
  return !(Array.isArray(data[prop]) && data[prop].length > 0);
};

// 创建 node 节点
function renderNode(h, data, context) {
  var props = context.props;

  var cls = ['org-tree-node'];
  var childNodes = [];
  var children = data[props.props.children];

  if (isLeaf(data, props.props.children)) {
    cls.push('is-leaf');
  } else if (props.collapsable && !data[props.props.expand]) {
    cls.push('collapsed');
  }

  childNodes.push(renderLabel(h, data, context));

  if (!props.collapsable || data[props.props.expand]) {
    childNodes.push(renderChildren(h, children, context));
  }

  return h('div', {
    domProps: {
      className: cls.join(' ')
    }
  }, childNodes);
}

// 创建展开折叠按钮
function renderBtn(h, data, _ref) {
  var props = _ref.props,
      listeners = _ref.listeners;

  var expandHandler = listeners['on-expand'];

  var cls = ['org-tree-node-btn'];

  if (data[props.props.expand]) {
    cls.push('expanded');
  }

  return h('span', {
    domProps: {
      className: cls.join(' ')
    },
    on: {
      click: function click(e) {
        return expandHandler && expandHandler(e, data);
      }
    }
  });
}

// 创建 label 节点
function renderLabel(h, data, context) {
  var props = context.props,
      listeners = context.listeners;

  var label = data[props.props.label];
  var renderContent = props.renderContent;

  // event handlers
  var clickHandler = listeners[EVENTS.CLICK];
  var mouseOutHandler = listeners[EVENTS.MOUSEOUT];
  var mouseOverHandler = listeners[EVENTS.MOUSEOVER];
  var dragStartHandler = listeners[EVENTS.DRAGSTART];
  var dragOverHandler = listeners[EVENTS.DRAGOVER];
  var dropHander = listeners[EVENTS.DROP];

  var childNodes = [];
  if (typeof renderContent === 'function') {
    var vnode = renderContent(h, data);

    vnode && childNodes.push(vnode);
  } else {
    childNodes.push(label);
  }

  if (props.collapsable && !isLeaf(data, props.props.children)) {
    childNodes.push(renderBtn(h, data, context));
  }

  var cls = ['org-tree-node-label-inner'];
  var labelWidth = props.labelWidth,
      labelClassName = props.labelClassName,
      selectedClassName = props.selectedClassName,
      selectedKey = props.selectedKey;


  if (typeof labelWidth === 'number') {
    labelWidth += 'px';
  }

  if (typeof labelClassName === 'function') {
    labelClassName = labelClassName(data);
  }

  labelClassName && cls.push(labelClassName);

  // add selected class and key from props
  if (typeof selectedClassName === 'function') {
    selectedClassName = selectedClassName(data);
  }

  selectedClassName && selectedKey && data[selectedKey] && cls.push(selectedClassName);

  return h('div', {
    domProps: {
      className: 'org-tree-node-label',
      draggable: true
    },
    on: {
      'dragstart': createListener(dragStartHandler, data),
      'dragover': createListener(dragOverHandler, data),
      'drop': createListener(dropHander, data)
    }
  }, [h('div', {
    domProps: {
      className: cls.join(' ')
    },
    style: { width: labelWidth },
    on: {
      'click': createListener(clickHandler, data),
      'mouseout': createListener(mouseOutHandler, data),
      'mouseover': createListener(mouseOverHandler, data)
    }
  }, childNodes)]);
}

// 创建 node 子节点
function renderChildren(h, list, context) {
  if (Array.isArray(list) && list.length) {
    var children = list.map(function (item) {
      return renderNode(h, item, context);
    });

    return h('div', {
      domProps: {
        className: 'org-tree-node-children'
      }
    }, children);
  }
  return '';
}

function render(h, context) {
  var props = context.props;


  return renderNode(h, props.data, context);
}

/* harmony default export */ __webpack_exports__["a"] = (render);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-tree-container"},[_c('div',{staticClass:"org-tree",class:{horizontal: _vm.horizontal, collapsable: _vm.collapsable}},[_c('org-tree-node',{attrs:{"data":_vm.data,"props":_vm.props,"horizontal":_vm.horizontal,"label-width":_vm.labelWidth,"collapsable":_vm.collapsable,"render-content":_vm.renderContent,"label-class-name":_vm.labelClassName,"selected-class-name":_vm.selectedClassName,"selected-key":_vm.selectedKey},on:{"on-expand":function (e, data) { return _vm.$emit('on-expand', e, data); },"on-node-focus":function (e, data) { return _vm.$emit('on-node-focus', e, data); },"on-node-click":function (e, data) { return _vm.$emit('on-node-click', e, data); },"on-node-mouseover":function (e, data) { return _vm.$emit('on-node-mouseover', e, data); },"on-node-mouseout":function (e, data) { return _vm.$emit('on-node-mouseout', e, data); },"on-node-drag-start":function (e, data) { return _vm.onDragStart(e, data); },"on-node-drag-over":function (e, data) { return _vm.onDragOver(e, data); },"on-node-drop":function (e, data) { return _vm.onDrop(e, data); }}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js